import React, { useEffect, useState } from 'react';
import Skeleton from '@material-ui/lab/Skeleton';

const Skeletoncnt = () => {

    const [arry, setArry] = useState([1, 2, 3, 4, 5, 6, 7, 8, 9, 11, 12, 14, 15, 16, 17, 18, 19, 20])

    return (
        <div className="skltn-cnt">

            <Skeleton variant="rect" width={50 + '%'} height={280} />
            <div className="text">
                {arry.slice(0, 8).map((info, index) =>
                    <Skeleton key={index} variant="text" width={100 + '%'} height={26} />
                )}
            </div>
            {arry.slice(0, 4).map((info, index) =>
                <Skeleton key={index} variant="text" width={100 + '%'} height={26} />
            )}
            <div className="text lst">
                {arry.slice(0, 8).map((info, index) =>
                    <Skeleton key={index} variant="text" width={100 + '%'} height={26} />
                )}
            </div>
            <Skeleton variant="rect" width={50 + '%'} height={280} />

        </div>
    );
}

export default Skeletoncnt;